module.exports = __webpack_public_path__ + "img/Wp_2010.409805c4.png";